<template>
  <div class="FilterFormWrapper">
    <div class="FilterForm">
      Filter By:
      <select v-model="filter" @change="selectCreativeFilter($event)">
        <option value="" placeholder>{{directionPlaceholder}}</option>
        <option v-for="direction in sortedDirections" v-bind:value="direction.id" v-bind:key="direction.id">{{direction.displayName}}</option>
      </select>
    </div>
    <div class="FilterForm">
      Group By: <DropDown :options="groupByOptions" :placeholder="'Group By'" v-on:changeEvent="selectGroupBy($event)"/>
    </div>
  </div>
</template>

<script>
import DropDown from '../components/ui/DropDown.vue'


export default {
  name: 'filterForm',
  components: {
    DropDown
  },
  props: {
    elementName: String
  },
  data(){
    return {
      filter: null
    }
  },
  methods: {
    selectCreativeFilter: function(event){
      var directionID = event.target.value
      var filterValue = {}
      if (directionID) {
        filterValue = {
          field: "direction",
          fieldType: "reference",
          value: directionID,
          id: `direction-${directionID}`
        }
        this.$store.commit('addDeliverableFilter',filterValue);
      } else {
        this.$store.commit('removeDeliverableFilter');
      }
      this.$store.commit('toggleVisibility',this.elementName);
    },
    selectGroupBy: function(value){
      this.$store.commit('updateDeliverableGroupBy', value)
      this.$store.commit('toggleVisibility',this.elementName);
    }
  },
  computed: {
    directionPlaceholder(){
      if (Object.keys(this.$store.state.deliverableTransformations.filters).length > 1){
        return "Remove Filter"
      } else {
        return "Creative Direction"
      }
    },
    groupByOptions () {
      return [{
        id: "direction",
        name: "Creative Direction"
      },{
        id: "batch",
        name: "Delivery Batch"
      }]
    },
    sortedDirections () {
      return this.$store.getters.directionArray
    },
  }
}
</script>

<style>
  .FilterFormWrapper {
    background-color: #2E303A;
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
  }
  .FilterForm {
    padding: 15px;
    width: 100%;
  }
  .FilterForm select {
    background-color: #333746;
    border: none;
    height: 40px;
    color: #FFFFFF80;
    width: 300px;
    font-size: 14px;
  }
</style>
